var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-banner"},[_c('div',{staticClass:"container"},[_c('span',[_vm._v("Rabbitzhop "+_vm._s(_vm.$t('emailPage.bannerText')))]),_c('span',[_vm._v("Receipt #1717-6772")])])])}
var staticRenderFns = []

export { render, staticRenderFns }